import angular from 'angular';
import SalesReactivationController from './reactivation.controller';
import Routes from './reactivation.routes';

export default angular.module('autoboard.reactivateVehicle', [])
  .config(Routes)
  .controller('SalesReactivationController', SalesReactivationController)
  .name;
